import { Stack, styled, Typography } from '@mui/material'
import { useState, type FC } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS, unit } from '@hcr/ui'

import { ButtonBuyAccommodation, OwnerBuyAccommodationDrawer } from '../../../../common'

export const BookingListEmpty: FC = () => {
  const { t } = useTranslation()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const openDrawer = () => setIsDrawerOpen(true)
  const closeDrawer = () => setIsDrawerOpen(false)

  return (
    <Container>
      <Typography variant='bodyM' textAlign='center'>
        {t('booking.no-bookings')}
      </Typography>

      <ButtonBuyAccommodation
        isDrawerOpen={isDrawerOpen}
        onClickOpenDrawer={openDrawer}
        variant='outlined'
        color='black'
      />

      <OwnerBuyAccommodationDrawer isOpen={isDrawerOpen} onClose={closeDrawer} />
    </Container>
  )
}

const Container = styled(Stack)`
  gap: ${unit(4)};
  padding: ${unit(6)} ${unit(4)};
  border: ${unit(0.5)} dashed ${COLORS.semantic.divider};
  width: 100%;
`
